import Countries from '@wetransfer/transfer/modules/i18n/countries';
import States from '@wetransfer/transfer/modules/i18n/states';

export const countryHelpers = {
  getCountryByCode(countryCode) {
    return Countries.find((country) => {
      return country.id === countryCode;
    });
  },

  getCountryByName(countryName) {
    return Countries.find((country) => {
      return country.label === countryName;
    });
  },
};

export const stateHelpers = {
  getStateByCode(stateCode) {
    return States.find((state) => {
      return state.id === stateCode;
    });
  },

  getStateByName(stateName) {
    return States.find((state) => {
      return state.label === stateName;
    });
  },
};
